import { Column } from 'react-table'
import cn from 'classnames'

import { PenIcon } from '@components/icons/PenIcon'
import { HeaderWithSort } from '@components/Table/HeaderWithSort'
import { SortEnum } from '@interfaces/SortEnum'
import { SalesAnalyticsDataEbookTableType } from '@models/myWriting/salesAndAnalytics/SalesAnalyticsDataEbookTableType'
import { formatDatetime } from '@lib/utils'
import {
  EbookSalesStatusEnum,
  ebookSalesStatusValue,
} from '@interfaces/EbookSalesStatusEnum'
import { SortEbookTableType } from './interface'

export function columnsSales({
  sortParams,
  isMobile,
  handleSortChange,
}: {
  sortParams: SortEbookTableType
  isMobile: boolean
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <div className='text-secondary-1 text-[12px] w-full text-left desktop-tablet:pl-[20px]'>
          ชื่อเรื่อง
        </div>
      ),
      id: 'ebookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className=''>{record.ebookTitle}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวน(เหรียญ)'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className='text-right w-[70px] min-w-[70px]'>
          {record.total.toLocaleString()}
        </div>
      ),
      minWidth: 120,
      width: 200,
    },
  ]

  if (!isMobile) {
    columns.unshift({
      Header: <div />,
      id: 'emptyColumn',
      Cell: () => <div />,
      minWidth: 150,
      width: 150,
    })
  }

  return columns
}

export function columnsTotalSales({
  sortParams,
  isMobile,
  handleSortChange,
}: {
  sortParams: SortEbookTableType
  isMobile: boolean
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <div className='text-secondary-1 text-[12px] w-full text-left desktop-tablet:pl-[20px]'>
          ชื่อเรื่อง
        </div>
      ),
      id: 'ebookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div>{record.ebookTitle}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวนครั้งที่ขาย'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className='text-right w-[80px] min-w-[80px]'>
          {record.total.toLocaleString()}
        </div>
      ),
      minWidth: 120,
      width: 200,
    },
  ]

  if (!isMobile) {
    columns.unshift({
      Header: <div />,
      id: 'emptyColumn',
      Cell: () => <div />,
      minWidth: 150,
      width: 150,
    })
  }

  return columns
}

export function columnsView({
  sortParams,
  isMobile,
  handleSortChange,
}: {
  sortParams: SortEbookTableType
  isMobile: boolean
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <div className='text-secondary-1 text-[12px] w-full text-left desktop-tablet:pl-[20px]'>
          ชื่อเรื่อง
        </div>
      ),
      id: 'ebookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div>{record.ebookTitle}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวน(วิว)'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className='text-right w-[50px] min-w-[50px]'>
          {record.total.toLocaleString()}
        </div>
      ),
      minWidth: 120,
      width: 200,
    },
  ]

  if (!isMobile) {
    columns.unshift({
      Header: <div />,
      id: 'emptyColumn',
      Cell: () => <div />,
      minWidth: 150,
      width: 150,
    })
  }

  return columns
}

export function columnsPreRead({
  sortParams,
  isMobile,
  handleSortChange,
}: {
  sortParams: SortEbookTableType
  isMobile: boolean
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <div className='text-secondary-1 text-[12px] w-full text-left desktop-tablet:pl-[20px]'>
          ชื่อเรื่อง
        </div>
      ),
      id: 'ebookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div>{record.ebookTitle}</div>
      ),
      minWidth: 120,
      width: 200,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวนทดลองอ่าน(ครั้ง)'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className='text-right w-[120px] min-w-[120px]'>
          {record.total.toLocaleString()}
        </div>
      ),
      minWidth: 120,
      width: 200,
    },
  ]

  if (!isMobile) {
    columns.unshift({
      Header: <div />,
      id: 'emptyColumn',
      Cell: () => <div />,
      minWidth: 150,
      width: 150,
    })
  }

  return columns
}

export function columnsPromotion({
  sortParams,
  handleSortChange,
}: {
  sortParams: SortEbookTableType
  handleSortChange: (sortKey: string, sortValue: SortEnum) => void
}): Column[] {
  const columns: Column[] = [
    {
      Header: (
        <HeaderWithSort
          text='ชื่อเรื่อง'
          sortKey='ebookTitle'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'ebookTitle',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className='grid grid-cols-[77px_1fr]'>
          {record.coverImgPath ? (
            <img
              className='w-[57px] h-[80px] rounded-lg'
              src={record.coverImgPath}
              alt='ebook-sales'
            />
          ) : (
            <div className='w-[57px] h-[80px] rounded-lg  bg-gray' />
          )}
          <div className='flex flex-col justify-between h-full '>
            <div className='flex items-center text-secondary-1 text-[12px] '>
              <div className='flex mr-[10px]  text-secondary '>
                <PenIcon className='w-[18px] h-[18px] shrink-0 mr-[5px]' />
                <span className='max-w-[200px] line-clamp-1 break-all '>
                  {record.penName}
                </span>
              </div>
              {record.category}
            </div>
            <div className='text-[14px] font-light line-clamp-2'>
              {record.ebookTitle}
            </div>
          </div>
        </div>
      ),
      minWidth: 430,
      width: 430,
    },
    {
      Header: (
        <div className='text-secondary-1 text-[12px] w-full text-left desktop-tablet:pl-[20px]'>
          รูปแบบโปรโมชัน
        </div>
      ),
      id: 'promotionType',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div>
          ลดราคา {record.discountCoinValue.toLocaleString()}
          {` เหรียญ (${record.discountPercentValue}%)`}
        </div>
      ),
      minWidth: 180,
      width: 180,
    },
    {
      Header: (
        <HeaderWithSort
          text='ราคาตั้ง(เหรียญ)'
          sortKey='rawPrice'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'rawPrice',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className='text-right'>{record.rawPrice?.toLocaleString()}</div>
      ),
      minWidth: 80,
      width: 80,
    },
    {
      Header: (
        <HeaderWithSort
          text='ราคาที่ลดแล้ว(เหรียญ)'
          sortKey='discountedPrice'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'discountedPrice',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className='text-right'>
          {record.discountedPrice?.toLocaleString()}
        </div>
      ),
      minWidth: 80,
      width: 80,
    },
    {
      Header: (
        <HeaderWithSort
          text='ระยะเวลาโปรโมชั่น'
          sortKey='promotionStartedAt'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'promotionStartedAt',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className='flex flex-col justify-between h-[80px] text-[14px] font-light'>
          <span
            className={cn('font-bold', {
              'text-primary':
                record.promotionStatus ===
                EbookSalesStatusEnum.PROMOTION_PERIOD,
              'text-red':
                record.promotionStatus ===
                EbookSalesStatusEnum.PROMOTION_CLOSED,
              'text-secondary-1':
                record.promotionStatus === EbookSalesStatusEnum.PROMOTION_ENDED,
              'text-green':
                record.promotionStatus ===
                EbookSalesStatusEnum.PROMOTION_NOT_START_YET,
            })}
          >
            {ebookSalesStatusValue[record.promotionStatus]}
          </span>
          <div className='mt-auto'>
            <p>{formatDatetime(record.promotionStartedAt)} -</p>
            <p>{formatDatetime(record.promotionEndedAt)}</p>
          </div>
        </div>
      ),
      minWidth: 190,
      width: 190,
    },
    {
      Header: (
        <HeaderWithSort
          text='จำนวนที่ขาย(ครั้ง)'
          sortKey='total'
          sortValue={sortParams.sortValue}
          sortKeySelected={sortParams.sortKey}
          onClick={handleSortChange}
        />
      ),
      id: 'total',
      Cell: ({ record }: { record: SalesAnalyticsDataEbookTableType }) => (
        <div className='text-right'>{record.total.toLocaleString()}</div>
      ),
      minWidth: 80,
      width: 80,
    },
  ]
  return columns
}
